export class SplitView {
	constructor() {
		this.$firstStadium = $("#js-first-stadium");
		this.$secondStadium = $("#js-second-stadium");

		this.$firstSector = $("#js-first-sector");
		this.$secondSector = $("#js-second-sector");

		this.$firstStadiumPlan = $("#js-first-stadium svg");
		this.$secondStadiumPlan = $("#js-second-stadium svg");

		this.$backToStadiumBtn = $(".js-back-stadium");

		/** tabs */
		this.$splitTabs = $("#js-split-tabs");
		this.$stadiumTab = $(".js-stadium-tab");

		this.$cancelOrderBtn = $("#js-cancel-order");

		/* Переменные для управления стадионом */
		this.$bottomButton = $("#js-bottom-button");
		
		this.$continueButton = $("#js-continue");
		this.$secondStadiumTab = $("#js-tab-second-stadium");
	}
}
